import React from 'react';
import styled from 'styled-components';
import Header from '../../components/common/header/Header';

const SiInfoBlock = styled.div`
    width: 100%;
    margin: 0 auto;
    padding-top: 80px;
`;

const SiInfoContentsBlock = styled.div`
    padding: 90px 50px 120px;
`;

const SiInfoTableBlock = styled.table`

    border-top: 2px solid #111;
    border-bottom: 0px solid #ccc;
    
    th {
        padding: 13px 5px 14px;
        font-size: 14px;
        text-align: center;
    }

    td {
        line-height: 1.5;
        position: relative;
        padding: 20px;
        border-top: 1px solid #ccc;
        vertical-align: middle;
        font-size: 15px;
      }

      td.border_bottom {
        border-bottom: 1px solid #ccc;
      }

      td.border_right {
        border-right: 1px solid #ccc;
      }

      td.border_black {
        border-bottom: 1px solid #111;
      }

      td.border_none {
        border-top: none;
      }

      td.border_t-none {
        border-top: none;
      }

      td.padding_none {
        padding: 6px 0;
      }

      td.thumb_none {
        padding-left: 120px;
      }

      b {
        font-weight: 700;
      }

      .mint {
        background-color: rgba(0, 217, 184, 0.1);
      }

      .gray {
        background-color: #f4f4f4;
      }

      .input-box .text-input:disabled {
        color: #999;
        background-color: #e7e7e7;
      }
`;



// 페이지 정보 보기 - 관리자용 
const SiInfo = () => {
    return (
        <SiInfoBlock>
            <Header />
            <SiInfoContentsBlock>
                <SiInfoTableBlock>
                    <colgroup>
                        <col width="180px;" />
                        <col width="410px;" />
                        <col width="180px;" />
                        <col width="410px;" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td className="gray">ENV</td>
                            <td colSpan="3"><span>{process.env.REACT_APP_HOST_ENV}</span></td>
                        </tr>
                        <tr>
                            <td className="gray">API_URL</td>
                            <td colSpan="3"><span>{process.env.REACT_APP_API_URL}</span></td>
                        </tr>
                        <tr>
                            <td className="gray">RANDOM-KEY</td>
                            <td colSpan="3"><span>{Math.floor(Math.random() * 100000000)}{process.env.REACT_APP_BOOTPAY_ID}{Math.floor(Math.random() * 100)}</span></td>
                        </tr>
                    </tbody>

                </SiInfoTableBlock>
            </SiInfoContentsBlock>
        </SiInfoBlock>
    );
};

export default SiInfo;